// extracted by mini-css-extract-plugin
module.exports = {"forum":"forum--3sG65","forum_list":"forum_list--3P2dO","loading":"loading--1vKPi"};